<div class="item-grid-container py-2 pt-2">
  <div class="account-details-label">
    <mat-card class="account-details-card text-white" [ngClass]>
      <ul class="list-inline d-inline-flex">
        <li class="list-inline-item align-self-center d-inline-block d-xl-none">
          <button mat-mini-fab aria-label="toggle show hide" color="primary" (click)="showCard = !showCard">
            <mat-icon *ngIf="!showCard">arrow_back_ios</mat-icon>
            <mat-icon *ngIf="showCard">arrow_forward_ios</mat-icon>
          </button>
        </li>
        <li class="list-inline-item">
          <ul class="list-unstyled" *ngIf="showCard">
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.userName </span>:
                {{ retailerData.retailerUserName }}
              </h4>
            </li>
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.accountNumber </span>:
                {{ retailerAccountNum }}
              </h4>
            </li>
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.availableBalance </span>:
                {{ currentAmount | currency }}
              </h4>
            </li>
            <li></li>
          </ul>
        </li>
      </ul>
      
    </mat-card>
  </div>
  <mat-card class="shadow">
    <form
      [formGroup]="addPaymentInfoForm"
      (ngSubmit)="onAddRetailerPaymentSubmit()"
    > 
      <h5 class="content-label-each" translate>
        pages.newRetailer.businessInformation
      </h5>
      <div class="buss-info-details content-details-blk">
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.businessName<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="{{ 'pages.placeholders.EnterBusinessname' | translate }}"
                  formControlName="businessName"
                  required
                />
              </mat-form-field>
              <div *ngIf="f.businessName.touched && f.businessName.invalid">
                <div *ngIf="f.businessName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Businessnameisrequired' | translate }}</mat-hint
                  >
                </div>
                <mat-hint class="text-danger ms-2" *ngIf="f.businessName.hasError('minlength') ||f.businessName.hasError('maxlength')"
                  >Min length: 5 & Max length : 50</mat-hint
                >
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.dbaName<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  placeholder="{{'pages.AddRetailer.EnterDBAname' | translate }}"
                  formControlName="dbaName"
                />
              </mat-form-field>
              <div *ngIf="f.dbaName.touched && f.dbaName.invalid">
                <div *ngIf="f.dbaName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{'pages.placeholders.DBANameisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.businessType<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="businessType"
                  placeholder="Select business type"
                >
                  <mat-option
                    *ngFor="let businessType of businessTypes"
                    [value]="businessType"
                  >
                    {{ businessType }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="f.businessType.touched && f.businessType.invalid">
                <div *ngIf="f.businessType.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Businesstypeisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.businessNumber<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: phone }"
                  required
                  formControlName="businessNumber"
                  placeholder="{{'pages.AddRetailer.Enterbusinessphonenumber' | translate }}"
                />
                <!-- <span matPrefix>+1</span> -->
              </mat-form-field>
              <div *ngIf="f.businessNumber.invalid">
                <div *ngIf="f.businessNumber.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Businessnumberisrequired' | translate }}</mat-hint
                  >
                </div>
                <div *ngIf="f.businessNumber.errors.pattern">
                  <mat-hint class="text-danger ms-2"
                    >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.businessCertificate<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  formControlName="businessCertificate"
                  placeholder="{{ 'pages.placeholders.Enterbusinesscertificate' | translate }}"
                />
              </mat-form-field>
              <div
                *ngIf="
                  f.businessCertificate.touched &&
                  f.businessCertificate.invalid
                "
              >
                <div *ngIf="f.businessCertificate.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Businesscertificateisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.confirmationNumber
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="number"
                  formControlName="confirmationNumber"
                  placeholder="{{'pages.AddRetailer.Enterconfirmationnumber' | translate }}"
                />
              </mat-form-field>
              <div
                *ngIf="
                  f.confirmationNumber.touched &&
                  f.confirmationNumber.invalid
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>pages.newRetailer.managerName</h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="managerName"
                  placeholder="{{ 'pages.placeholders.Entermanagername' | translate }}"
                />
              </mat-form-field>
              <!-- <div *ngIf="f.managerName.touched && f.managerName.invalid">
                <div *ngIf="f.managerName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Managernameisrequired' | translate }}</mat-hint
                  >
                </div>
              </div> -->
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>pages.newRetailer.managerNumber</h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="managerNumber"
                  [textMask]="{ mask: phone }"
                  placeholder="{{'pages.placeholders.EnterManagerNumber' | translate }}"
                />
              </mat-form-field>
              <!-- <div
                *ngIf="f.managerNumber.touched && f.managerNumber.invalid"
              >
                <div *ngIf="f.managerNumber.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                  >
                </div>
                <div *ngIf="f.managerNumber.errors.pattern">
                  <mat-hint class="text-danger ms-2">
                    Enter 10 digit m=number
                  </mat-hint>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.address<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  formControlName="address"
                  placeholder="{{'pages.AddRetailer.Enteraddress' | translate }}"
                />
              </mat-form-field>
              <div *ngIf="f.address.touched && f.address.invalid">
                <div *ngIf="f.address.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Addressisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.city<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  formControlName="city"
                  placeholder="{{'pages.AddRetailer.Entercity' | translate }}"
                />
              </mat-form-field>
              <div *ngIf="f.city.touched && f.city.invalid">
                <div *ngIf="f.city.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Cityisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.state<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="state"
                  placeholder="{{'pages.AddRetailer.SelectState' | translate }}"
                >
                  <mat-option
                    *ngFor="let state of usStateZips"
                    [value]="state"
                  >
                    {{ state }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="f.state.touched && f.state.invalid">
                <div *ngIf="f.state.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Stateisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.zipCode<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  type="text"
                  formControlName="zipCode"
                  placeholder="{{
                    'pages.newRetailer.enterZipCode' | translate
                  }}"
                />
              </mat-form-field>
              <div *ngIf="f.zipCode.touched && f.zipCode.invalid">
                <div *ngIf="f.zipCode.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.ZIPisrequired' | translate }}</mat-hint
                  >
                </div>
                <div *ngIf="f.zipCode.errors.pattern">
                  <mat-hint class="text-danger ms-2"
                    >{{ 'pages.placeholders.InvalidZIPformat' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              Retailer Language
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select formControlName="language" placeholder="Select Retailer Language">
                  <mat-option value="English">
                    English
                  </mat-option>
                  <mat-option value="Spanish">
                    Spanish
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          </div>
      </div>
      
      <h5 class="content-label-each" translate>
        pages.newRetailer.accountInformation
      </h5>
      <div class="account-info-details content-details-blk">
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.status<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="status"
                  placeholder="{{'pages.AddProviders.SelectStatus' | translate }}"
                  [(value)]="selectedStatus"
                  [disabled]="disableStatus"
                >
                
                <mat-option
                *ngFor="let status of statusOptions"
                [value]="status"
                [disabled]="disableOption(status)"
              >
                {{ status }}
              </mat-option>
                </mat-select>
              </mat-form-field>
              
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.account#<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  disabled
                  readonly
                  formControlName="retailerAccountNum"
                  placeholder="{{
                    'pages.newRetailer.accountNumber' | translate
                  }}"
                />
              </mat-form-field>
              <mat-hint
                class="cur-point text-underline"
                (click)="onLinkedAcountsClick($event)"
                ><br /><span class="mi mi-link small-icon"></span> Linked
                accounts</mat-hint
              >
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.accountType
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  matInput
                  readonly
                  formControlName="accountType"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Edit Payment Method (ACH, CC, D D)'"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.paymentOption<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Edit Payment Method (ACH, CC, D D)'"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="paymentOption"
                  required
                  placeholder="Select payment type"
                >
                  <mat-option
                    *ngFor="let option of paymentOptions"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Edit Billing Schedule'"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.invoiceOption
              <span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Edit Billing Schedule'"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="invoiceOption"
                  required
                  placeholder="Select Option"
                  [disabled]="rolecheck()" 
                >
                  <mat-option
                    *ngFor="let invType of invoiceType"
                    [value]="invType.type"
                  >
                  <span translate>  {{ invType.translate }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
              <div
                *ngIf="f.invoiceOption.touched && f.invoiceOption.invalid"
              >
                <div *ngIf="f.invoiceOption.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Invoiceoptionisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.firstName<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  formControlName="firstName"
                  [readonly]="readonly()"
                  placeholder="{{'pages.AddRetailer.Enterfirstname' | translate }}"
                />
              </mat-form-field>
              <div *ngIf="f.firstName.touched && f.firstName.invalid">
                <div *ngIf="f.firstName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Firstnameisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.lastName<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  [readonly]="readonly()"
                  formControlName="lastName"
                  placeholder="{{'pages.AddRetailer.Enterlastname' | translate }}"
                />
              </mat-form-field>
              <div *ngIf="f.lastName.touched && f.lastName.invalid">
                <div *ngIf="f.lastName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Lastnameisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0" >
          
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.mobileNumberForOTP <span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline" class="p-0">
                <input
                  matInput
                  [textMask]="{ mask: phone }"
                  required
                  [readonly]="readonly()"
                  placeholder="{{
                    'pages.newRetailer.enterMobilenumber' | translate
                  }}"
                  formControlName="otpMobileNumber"
                /> 
                <!-- <span matPrefix>+1</span> -->
              </mat-form-field>
              <div
                *ngIf="
                  f.otpMobileNumber.touched && f.otpMobileNumber.invalid
                "
              >
                <div *ngIf="f.otpMobileNumber.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                  >
                </div>
                <div *ngIf="f.otpMobileNumber.errors.pattern">
                  <mat-hint class="text-danger ms-2"
                    >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.emailInput<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  required
                  [readonly]="readonly()"
                  placeholder="{{'pages.AddRetailer.EnteremailAddress' | translate }}"
                  formControlName="email"
                />
              </mat-form-field>
              <div *ngIf="f.email.touched && f.email.invalid">
                <div *ngIf="f.email.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.EmailIdisrequired' | translate }}</mat-hint
                  >
                </div>
                <div *ngIf="f.email.errors.pattern">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Invalidformat' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        
        
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Assign Sales Rep/Distributor'"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.salesRepDist<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          *hideIfUnauthorized="'Assign Sales Rep/Distributor'"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="assignSalesReps"
                  required
                  placeholder="{{'pages.AddRetailer.SelectsalesRepDist' | translate }}"
                  [(value)]="selectedsalesrep"
                  (selectionChange)="onsalesrepSelected($event)"
                >
                  <mat-option
                    *ngFor="let salesRep of salesReps"
                    [value]="salesRep.userId"
                  >
                    {{ salesRep.displayName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  f.assignSalesReps.touched && f.assignSalesReps.invalid
                "
              >
                <div *ngIf="f.assignSalesReps.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ "pages.AddRetailer.DistributorRepIsRequired" | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.pricelist<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="assignPriceList"
                  placeholder="{{'pages.AddRetailer.SelectPricelist' | translate }}"
                >
                  <mat-option
                    *ngFor="let pricelist of pricelists"
                    [value]="pricelist"
                  >
                    {{ pricelist }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint
                class="cur-point text-underline"
                (click)="onDownlaodPriceList($event)"
                [ngStyle]="{'display': userRole === 'Sales Rep' || userRole === 'Customer Service' || userRole === 'Distributor' ?'none':''}"
                ><br />
                <i class="mi mi-save-alt small-icon"></i><span translate class="translate">pages.newRetailer.downloadpricelist</span>
              </mat-hint>
              <div
                *ngIf="
                  f.assignPriceList.touched && f.assignPriceList.invalid
                "
              >
                <div *ngIf="f.assignPriceList.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Pricelistassignmentisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.OfTransactionsHr<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="transactionCountPerhr"
                  placeholder="{{ 'pages.placeholders.Settransactionlimit' | translate }}"
                >
                  <mat-option
                    *ngFor="let limit of transactionPerHr"
                    [value]="limit"
                  >
                    {{ limit }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
              <div
                *ngIf="
                  f.transactionCountPerhr.touched &&
                  f.transactionCountPerhr.invalid
                "
              >
                <div *ngIf="f.transactionCountPerhr.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.TransactionLimitisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.transactionAmtHr<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="transactionAmtPerhr"
                  placeholder="{{ 'pages.placeholders.Setamountlimit' | translate }}"
                >
                  <mat-option
                    *ngFor="let limitAmount of transactionAmtPerhr"
                    [value]="limitAmount"
                  >
                    {{ limitAmount | currency }}/Hr
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
              <div
                *ngIf="
                  f.transactionAmtPerhr.touched &&
                  f.transactionAmtPerhr.invalid
                "
              >
                <div *ngIf="f.transactionAmtPerhr.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.AmountLimitisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.OfTransactionsHr<span class="required"
                >*</span
              >
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="offTransactionCountPerhr"
                  placeholder="{{ 'pages.placeholders.SelectOffHourstransactions' | translate }}"
                >
                  <mat-option
                    *ngFor="
                      let transactionCount of offHoursTransactionCount
                    "
                    [value]="transactionCount"
                  >
                    {{ transactionCount }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="mx-3"
                ><br />Off-hours: 11 pm - 6 am
              </mat-hint>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.transactionAmtHr<span
                class="required"
                >*</span
              >
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="offTransactionAmtPerhr"
                  placeholder="{{ 'pages.placeholders.SelectOffHourstransactionamount' | translate }}"
                >
                  <mat-option
                    *ngFor="
                      let transactionAmount of offHoursTransactionAmount
                    "
                    [value]="transactionAmount"
                  >
                    {{ transactionAmount | currency }}/Hr
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-hint class="mx-3"
                ><br />Off-hours: 11 pm - 6 am
              </mat-hint>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label">
              {{ 'pages.placeholders.Threshold' | translate }}<span *ngIf="autoReloadStatus" class="required"
                >*</span
              >
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="threshold"
                  placeholder="{{'pages.AddRetailer.Selectthresholdamount' | translate }}"
                >
                  <mat-option>--</mat-option>
                  <mat-option
                    *ngFor="let amount of thresholdAmount"
                    [value]="amount"
                  >
                    {{ amount | currency }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="f.threshold.touched && f.threshold.invalid">
                <div *ngIf="f.threshold.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{ 'pages.placeholders.Thresholdamountisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.autorelaodamount
            </h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="autoReloadStatus"
                (change)="checkautoReloadStatus($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
          <div
            *ngIf="autoReloadStatus"
            class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: numberMask, guide: false }"
                  placeholder="Enter auto reload amount"
                  formControlName="autoReloadAmount"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row g-0" *ngIf="addPaymentInfoForm.get('accountType').value=='Postpaid' ">
          <div
          class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
             Auto Payment Status
            </h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="autoPaymentStatus"
                (change)="checkautoPaymentStatus($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              Tier Level
            </h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
          >
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  readonly
                  placeholder="retailer tier"
                  formControlName="tierLevel"
                />
              </mat-form-field>
            </div>
          </div>

        </div>
      </div>
      <div class="row  g-0">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h5 class="content-label-each" translate>
        pages.newRetailer.registration
      </h5>
      <div class="registration-info-details content-details-blk">
        <div class="row g-0">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.ipAddress
            </h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="ipAddressStatus"
                (change)="checkIpAddressStatus($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
          >
          <div class="form-item-input mx-2">
            <mat-form-field appearance="outline" class="w-100" *ngIf="ipAddressStatus">
              <input
                matInput
                placeholder="{{
                  'pages.newRetailer.ipAddress' | translate
                }}"
                type="text"
                formControlName="ipAddress"
              />
            </mat-form-field>
          </div>
          </div>
        </div>
        <div class="row g-0" *hideIfUnauthorized="'Registering IP Addresses & IVR'">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.IVRnumber
            </h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="ivrAccess"
                (change)="checkIsIvr($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
            *ngIf="ivrAccess"
          >
          <div class="row g-0">
            <div class="col-7">
              <div class="form-item-input mx-2">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: phone }"
                    placeholder="{{
                      'pages.newRetailer.IVRnumber' | translate
                    }}"
                    formControlName="ivrNumber"
                  />
                </mat-form-field>
              </div>
            </div>
             <div class="col-5">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-95">
                  <input
                    matInput
                    type="text"
                    pattern="[0-9]*"
                    maxlength="4"
                    placeholder="4 digit code"
                    formControlName="ivrCode"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          </div>
         
        </div>
      </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h5 class="content-label-each" translate>
        pages.newRetailer.notification
      </h5>
      <div class="notification-info-details content-details-blk">
        <div class="row g-0">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>pages.newRetailer.textMessage</h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="smsNotificationStatus"
                (change)="checkIsTextNotify($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
          >
            <h4 class="form-item-label" translate>
              pages.newRetailer.emailInput
            </h4>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3 align-self-center"
          >
            <div class="form-item-toggle">
              <mat-slide-toggle
                color="primary"
                class="mb-2"
                formControlName="emailNotificationStatus"
                (change)="checkEmailNotificationStatusNotify($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
      
      
      <h5 class="content-label-each" translate>pages.newRetailer.comments</h5>
      <div class="notification-info-details content-details-blk">
        <div class="row g-0">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
          >
            <mat-form-field appearance="outline" class="w-95">
              <textarea
                #comment
                matInput
                maxlength="100"
                placeholder="{{'pages.placeholders.Commentshere' | translate }}"
                class="text-area-comments"
                formControlName="comments"
              ></textarea>
              <p class="text-end mb-0">{{comment.value.length}}/100<p>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-footer">
        <ul class="list-inline text-center">
          <li class="list-inline-item">
            <button
              mat-raised-button
              [disabled]="checkSubmitDisplayed()" 
              color="primary"
              type="submit"
              class="rounded-0"
            >
              <span translate class="translate">pages.newRetailer.update</span>
            </button>
          </li>
          <li class="list-inline-item">
            <button
              mat-stroked-button
              color="primary"
              class="rounded-0"
              type="button"
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </li>
          <li class="list-inline-item"></li>
        </ul>
      </div>
    </form>
  </mat-card>
</div>
